

import { useEffect, useRef, useState } from "react";
import Button from "./Button";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const Searching = (props) => {
  const [search, setSearch] = useState("");
  const debounceTimerRef = useRef(null);
  const {
    data,
    setData,
    type,
    serverSearching,
    setSearchData,
    placeholder,
    button,
    newClass,
    btnShow,
    actionShow,
    paginationSubmitButton,
    setActionPagination,
    actionPagination,
    customSelectDataShow,
    customSelectData,
    label,
    actionPaginationDataCustom,
    className,
    isSubmitDisabled = false,
    hideActionDropdown = false,
    actionButtonLabel = "Submit",
    debounceMs = 400,
    inline = false,
    inputMaxWidth,
  } = props;

  const serverSearchingRef = useRef(serverSearching);
  const setSearchDataRef = useRef(setSearchData);
  const isFirstRender = useRef(true);

  useEffect(() => {
    serverSearchingRef.current = serverSearching;
    setSearchDataRef.current = setSearchData;
  }, [serverSearching, setSearchData]);

  useEffect(() => {
    if (!serverSearchingRef.current) return;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      const rawValue = search ?? "";
      if (serverSearchingRef.current) serverSearchingRef.current(rawValue);
      if (setSearchDataRef.current) setSearchDataRef.current(rawValue);
    }, debounceMs);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [search, debounceMs]);

  const handleSearch = (event) => {
    event.preventDefault();

    // Client-side search keeps existing behavior (case-insensitive filtering).
    // Server-side search is handled via the debounced effect above (raw query, no encoding).
    if (type === "client") {
      const searchValue = search ? search : event?.target?.value;
      const getLowerCaseSearch = searchValue?.toLowerCase();

      if (getLowerCaseSearch !== undefined) {
        if (getLowerCaseSearch) {
          const filteredData = data.filter((item) => {
            return Object.keys(item).some((key) => {
              if (key === "_id" || key === "updatedAt" || key === "createdAt") {
                return false;
              }
              const itemValue = item[key];
              if (typeof itemValue === "string") {
                return itemValue.toLowerCase().indexOf(getLowerCaseSearch) > -1;
              } else if (typeof itemValue === "number") {
                return itemValue.toString().indexOf(getLowerCaseSearch) > -1;
              } else if (typeof itemValue === "object" && itemValue !== null) {
                // Check for nested object (agencyId) and handle nested properties
                return Object.values(itemValue).some((nestedValue) => {
                  if (typeof nestedValue === "string") {
                    return (
                      nestedValue.toLowerCase().indexOf(getLowerCaseSearch) > -1
                    );
                  }
                  return false;
                });
              }
              return false;
            });
          });
          setData(filteredData); // Update the filteredData state
        } else {
          setData(data); // Reset the filteredData state to the original data
        }
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch(e);
    }
  };

  const paginationActionData = actionPaginationDataCustom ? actionPaginationDataCustom : ["Block", "Unblock", "Delete"];

  if (inline) {
    return (
      <div style={{ width: "100%", maxWidth: inputMaxWidth || 280 }}>
        <input
          type="search"
          autoComplete="false"
          placeholder={placeholder}
          aria-describedby="button-addon4"
          className="form-control"
          onChange={(e) => {
            const inputValue = e.target.value;
            setSearch(inputValue);
            if (!inputValue) {
              if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
              }
              handleSearch(e);
              if (serverSearching) {
                if (setSearchData) setSearchData("");
                serverSearching("");
              } else if (setData) {
                setData(data);
              }
            }
            if (type === "client") handleSearch(e);
          }}
          onKeyPress={handleKeyPress}
        />
      </div>
    );
  }

  return (
    <>
      <div className={`row search-action ${className || ""}`} >
        <div className="col-12 col-lg-6 col-md-6 col-sm-12">
          <div className=" searching-box " style={{ float: "right" }}>
            <div
              className={`prime-input search-input-box  m-0 ${newClass}`}
              style={{
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              {/* <label
                className="mb-3 mt-3"
                style={{ fontSize: "15px", fontWeight: "400", color: "unset" }}
              >
                {label}
              </label> */}

              <input
                type="search"
                autoComplete="false"
                placeholder={placeholder}
                aria-describedby="button-addon4"
                className="form-input searchBarBorderr "
                style={{
                  borderRadius: "5px !important",
                }}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  setSearch(inputValue);
                  if (!inputValue) {
                    if (debounceTimerRef.current) {
                      clearTimeout(debounceTimerRef.current);
                    }
                    handleSearch(e);
                    if (serverSearching) {
                      if (setSearchData) setSearchData("");
                      serverSearching("");
                    } else {
                      setData(data);
                    }
                  }
                  if (type === "client") handleSearch(e);
                }}
                onKeyPress={handleKeyPress}
              />

              {button && (
                <Button
                  type="button"
                  btnIcon={<SearchIcon />}
                  newClass={`themeBtn text-center fs-6  searchBtn text-white `}
                  onClick={(e) => handleSearch(e)}
                />
              )}
            </div>
          </div>
        </div>
        {actionShow === false ? (
          ""
        ) : (
          <div className={`${hideActionDropdown ? "col-12 col-lg-auto col-md-auto col-sm-12" : "col-12 col-lg-6 col-md-6 col-sm-12"} pagination-select p-0`}>
            <div className={`d-flex align-items-center justify-content-end pagination-box ${hideActionDropdown ? "" : "w-100"}`}>
              <>
                {/* <div className="pagination-submit me-3">
                  <FormControl>
                    <InputLabel
                      id="demo-simple-select-label"
                      style={{
                        fontWeight: "500",
                        fontSize: "17px",
                        marginBottom: "10px",
                      }}
                    >
                      Action
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={actionPagination}
                      label="Action"
                      onChange={(e) => setActionPagination(e.target.value)}
                    >
                      {customSelectDataShow
                        ? customSelectData?.map((item) => {
                            return (
                              <MenuItem value={item?.toLowerCase()} key={item}>
                                {item}
                              </MenuItem>
                            );
                          })
                        : paginationActionData?.map((item) => {
                            return (
                              <MenuItem value={item?.toLowerCase()} key={item}>
                                {item}
                              </MenuItem>
                            );
                          })}
                    </Select>
                  </FormControl>
                </div>
                <Button
                  newClass={"submit-btn-dialogue py-2"}
                  onClick={paginationSubmitButton}
                  btnName={"Submit"}
                  style={{marginRight: "10px"}}
                /> */}

                <div className={`d-flex gap-2 justify-content-end ${hideActionDropdown ? "" : "w-100"}`}>
                  {!hideActionDropdown && (
                    <div className="w-100">
                      <select
                        name=""
                        id=""
                        className="form-select "
                        value={actionPagination}
                        onChange={(e) => setActionPagination(e.target.value)}
                      >
                        {customSelectDataShow
                          ? customSelectData?.map((item) => {
                            return (
                              <option value={item?.toLowerCase()} key={item}>
                                {item}
                              </option>
                            );
                          })
                          : paginationActionData?.map((item) => {
                            return (
                              <option value={item?.toLowerCase()} key={item}>
                                {item}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  )}
                  <Button
                    newClass={"submit-btn"}
                    onClick={paginationSubmitButton}
                    btnName={actionButtonLabel}
                    disabled={isSubmitDisabled}
                  />
                </div>
              </>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Searching;
